<template>
  <a-form :form="form">
    <a-form-item
      v-for="item in formData"
      :key="item.name"
      :class="item.class"
      :label="item.lable"
      :colon="false"
      :label-col="{ span: item.lableCol }"
      :wrapper-col="{ span: item.wrapperCol }"
      :style="[item.isSelect ? styleOne : '', item.isSecond ? styleTwo : '']"
    >
      <slot :name="item.name" />
    </a-form-item>
  </a-form>
</template>
<script>
export default {
  props: ['formData', 'formLayout'],
  data() {
    return {
      form: this.$form.createForm(this),
      styleOne: {
        display: 'inline-block',
        width: '339px',
      },
      styleTwo: {
        paddingLeft: '20px',
        width: '310px',
      },
    };
  },
};
</script>
